<template>
  <el-dialog :title="$t('orgRelStaff.title')" :visible.sync="dialogVisible" width="80%" @close="handleClose">
    <el-row :gutter="20">
      <el-col :span="12" class="mb-20">
        <el-input v-model.trim="orgRelStaffInfo.name" :placeholder="$t('orgRelStaff.staffNamePlaceholder')" clearable
          class="input-with-button" style="width: calc(100% - 160px)">
          <el-button-group slot="append">
            <el-button type="primary" @click="_queryOrgRelStaffs">
              {{ $t('orgRelStaff.query') }}
            </el-button>
          </el-button-group>
        </el-input>
      </el-col>
    </el-row>

    <el-table :data="orgRelStaffInfo.staffs" border style="width: 100%" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" align="center"></el-table-column>
      <el-table-column prop="name" :label="$t('orgRelStaff.staffName')" align="center"></el-table-column>
      <el-table-column prop="tel" :label="$t('orgRelStaff.staffPhone')" align="center"></el-table-column>
      <el-table-column prop="userId" :label="$t('orgRelStaff.staffId')" align="center"></el-table-column>
    </el-table>

    <div class="pagination-container mt-20">
      <el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize"
        layout="total, prev, pager, next" :total="total"></el-pagination>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('orgRelStaff.close') }}</el-button>
      <el-button type="primary" @click="_saveOrgRelStaff">{{ $t('orgRelStaff.submit') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { listStaffsNoInOrg, saveStaffOrgRel } from '@/api/frame/orgApi'

export default {
  name: 'OrgRelStaff',
  data() {
    return {
      dialogVisible: false,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      orgRelStaffInfo: {
        orgId: '',
        name: '',
        staffs: [],
        selectStaffs: [],
        quanGroup: false
      }
    }
  },
  methods: {
    open(params) {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.resetForm()
        this.orgRelStaffInfo.orgId = params.orgId
        this._listStaffsNoInOrg()
      })
    },
    _listStaffsNoInOrg() {
      const params = {
        orgId: this.orgRelStaffInfo.orgId,
        page: this.currentPage,
        row: this.pageSize,
        staffName: this.orgRelStaffInfo.name
      }

      listStaffsNoInOrg(params).then(response => {
        this.orgRelStaffInfo.staffs = response.data
        this.total = response.total
      })
    },
    _saveOrgRelStaff() {
      if (this.orgRelStaffInfo.selectStaffs.length === 0) {
        this.$message.warning(this.$t('orgRelStaff.selectStaffFirst'))
        return
      }

      const params = {
        orgId: this.orgRelStaffInfo.orgId,
        staffIds: this.orgRelStaffInfo.selectStaffs.join(',')
      }

      saveStaffOrgRel(params).then(response => {
        this.$message.success(this.$t('orgRelStaff.saveSuccess'))
        this.dialogVisible = false
        this.$emit('notice')
      })
    },
    handleSelectionChange(val) {
      this.orgRelStaffInfo.selectStaffs = val.map(item => item.userId)
    },
    _queryOrgRelStaffs() {
      this.currentPage = 1
      this._listStaffsNoInOrg()
    },
    _resetOrgRelStaffs() {
      this.orgRelStaffInfo.name = ''
      this._queryOrgRelStaffs()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this._listStaffsNoInOrg()
    },
    resetForm() {
      this.orgRelStaffInfo = {
        orgId: '',
        name: '',
        staffs: [],
        selectStaffs: [],
        quanGroup: false
      }
      this.currentPage = 1
    },
    handleClose() {
      this.resetForm()
    }
  }
}
</script>

<style scoped>
.mb-20 {
  margin-bottom: 20px;
}

.mt-20 {
  margin-top: 20px;
}

.pagination-container {
  text-align: right;
}
</style>